import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Alert, Snackbar, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const toastTypes = {
  s: {
    severity: 'success',
    icon: <CheckCircleRoundedIcon />,
  },
  w: {
    severity: 'warning',
    icon: <WarningAmberRoundedIcon />,
  },
  e: {
    severity: 'error',
    icon: <ErrorRoundedIcon />,
  },
  i: {
    severity: 'info',
    icon: <InfoRoundedIcon />,
  },
};

export const Toaster = ({ message, type = 's', duration = 6000, handleClose }) => {
  if (!message) return null;

  const toast = toastTypes[type] || toastTypes.s;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={duration}
      onClose={handleClose}
      sx={{
        top: { xs: 12, sm: 24 },
        right: { xs: 12, sm: 24 },
        left: { xs: 12, sm: 'auto' },
      }}
    >
      <Alert
        severity={toast.severity}
        variant="outlined"
        icon={toast.icon}
        onClose={handleClose}
        role="status"
        sx={(theme) => {
          const color = theme.palette[toast.severity];

          return {
            width: { xs: '100%', sm: 420 },
            maxWidth: '100%',
            py: 1.25,
            px: 1.5,
            alignItems: 'center',
            borderRadius: 2.5,
            borderColor: alpha(theme.palette.common.white, 0.16),
            bgcolor: color.darker || color.dark,
            color: theme.palette.common.white,
            boxShadow: `0 18px 48px ${alpha(color.main, 0.28)}`,
            '& .MuiAlert-icon': {
              display: 'grid',
              placeItems: 'center',
              width: 38,
              height: 38,
              mt: 0,
              mr: 1.5,
              p: 0,
              borderRadius: 1.5,
              color: theme.palette.common.white,
              bgcolor: alpha(theme.palette.common.white, 0.14),
              boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.12)}`,
              '& svg': { fontSize: 22 },
            },
            '& .MuiAlert-message': {
              minWidth: 0,
              flex: 1,
              py: 0.25,
            },
            '& .MuiAlert-action': {
              pt: 0.25,
              pr: 0,
              ml: 1,
              color: alpha(theme.palette.common.white, 0.72),
              '&:hover': {
                color: theme.palette.common.white,
              },
            },
          };
        }}
      >
        <Typography
          component="div"
          variant="body2"
          sx={{
            color: 'rgba(255, 255, 255, 0.92)',
            fontSize: 13.5,
            fontWeight: 600,
            lineHeight: 1.5,
            letterSpacing: '0.005em',
          }}
        >
          {message}
        </Typography>
      </Alert>
    </Snackbar>
  );
};
